// extracted by mini-css-extract-plugin
export default {"container":"Lp-z","ratingLayout":"Mp-z","ratingLabel":"Np-z","nonInteractiveRatingLabel":"Op-z"};